/* eslint-disable */
// @ts-nocheck

import React, { useCallback, useEffect, useRef, useState } from 'react';
import { getSDK } from './getSDK';
import initializeRecorder from './initializeRecorder';
import { useVimeoService } from './useVimeoService';
import { EVideoState, EVimeoRecordWidgetEvent, IVimeoRecordWidget, TSdkState, TVideoReady } from './VimeoTypes';
// require('https://recordwidget.vimeocdn.com/recordwidget/v1/widget.js');

// tstrader private token for vimeo custom proj 'vendor-analysis' (with enterprise):
const vimeoAccessToken = '2feb59279b8a8e1f7d95b01f5457932a';
// oauth everything app token
// const vimeoAccessToken = 'cea6e05d23004ac51b0c4088a42c1847';
const SDK_URL = 'https://recordwidget.vimeocdn.com/recordwidget/v1/widget.js';
const SDK_GLOBAL = 'VimeoRecordWidget';

interface Props {
  isOpen: boolean;
  onComplete?: (videoId?: string, folderId?: string) => void;
  onInitialize?: () => void;
  onRecordingStart?: () => void;
  onRecordingCancel?: () => void;
  onRecordingStop?: () => void;
}

export function VimeoRecorder(props: Props) {
  const [videoInfo, setVideoInfo] = useState<any>();
  const [videoProcessed, setVideoProcessed] = useState(false);
  const recordInstance = useRef<IVimeoRecordWidget>();

  const handleVideoStateChange = (videoState: EVideoState, videoInfo: TVideoReady) => {
    // TODO refactor these to be enums
    switch (videoState) {
      // The recorded video has finished uploading;
      // videoInfo is null here:
      case EVideoState.VIDEO_UPLOADED: {
        break;
      }
      // The user has discarded (that is, deleted) the
      // recorded video; videoInfo is null here:
      case EVideoState.VIDEO_DISCARD:
        // act
        break;
      // The video has finished being uploaded and
      // optimized; videoInfo is an object here:
      case EVideoState.VIDEO_READY:
        // The user has clicked the Add button; videoInfo is an object here):
        setVideoInfo(videoInfo);
        if (videoInfo.videoReady && videoInfo.videoAdd) {
          // Here you can do actions with the videoInfo object; the video is
          // uploaded and optimized and the user has clicked the Add button.
        }
        break;
      case EVideoState.VIDEO_ADD:
        // The user can add the video before the video is even uploaded
        setVideoInfo(videoInfo);
        if (videoInfo.videoAdd) {
          props.onComplete && props.onComplete(videoInfo.id.toString());
        }
        break;
    }
  };

  useEffect(() => {
    if (!props.isOpen) {
      return;
    }

    getSDK(SDK_URL, SDK_GLOBAL).then((VimeoRecordWidget) => {
      recordInstance.current = new VimeoRecordWidget();

      initializeRecorder(vimeoAccessToken, recordInstance.current).then(() => {
        if (!recordInstance.current) {
          return;
        }
        recordInstance.current.on(EVimeoRecordWidgetEvent.SDK_STATE_EVENT, (sdkState: TSdkState) => {
          if (sdkState.isInitialized) {
            props.onInitialize && props.onInitialize();
          }

          // if the user clicks on the background blur to close the recorder
          if (!sdkState.isUIShown) {
            props.onComplete && props.onComplete();
          }
        });

        recordInstance.current.on(EVimeoRecordWidgetEvent.ANALYTICS, (eventName: TAnalyticsEventName) => {
          switch (eventName) {
            case 'recordingStartClicked': {
              props.onRecordingStart && props.onRecordingStart();
              break;
            }
            case 'recordingStopClicked': {
              props.onRecordingStop && props.onRecordingStop();
              break;
            }
            case 'cancelConfirmClicked': {
              props.onRecordingCancel && props.onRecordingCancel();
              break;
            }
          }
        });

        recordInstance.current.on(
          EVimeoRecordWidgetEvent.VIDEO_STATE_EVENT,
          (videoState: EVideoState, videoInfo: TVideoReady) => {
            handleVideoStateChange(videoState, videoInfo);
          }
        );

        recordInstance.current.activate(); // this is also an async function
      });
    });

    return () => {
      if (recordInstance.current && !recordInstance.current.isRecording) {
        recordInstance.current.dispose(); // this is also an async function
      }
    };
    // eslint-disable-next-line
  }, [props.isOpen]);

  return <></>;
}
